import { Col, TextLabel } from "../lib";
import { createStyles } from "../theme";
import { avatarStyles } from "./avatar";

type Props = {
  disabled?: boolean;
  userId: number;
  userName: string;
  small?: boolean;
};

export function AvatarText({
  disabled = false,
  small,
  userId,
  userName,
}: Props) {
  // Vars
  const isSupport = userId === 189481;
  const initials = isSupport
    ? "SMO"
    : userName.split(" ").reduce((acc, namePart) => acc + namePart[0], "");

  // Render
  return (
    <Col.C
      style={[
        avatarStyles.container,
        $.container,
        small && avatarStyles.small,
        disabled && $.disabled,
      ]}
    >
      <TextLabel em>{initials}</TextLabel>
    </Col.C>
  );
}

const $ = createStyles({
  container: {
    backgroundColor: "primaryDim",
    borderWidth: 1,
    borderColor: "primaryDim",
  },
  disabled: {
    backgroundColor: "surfaceDim",
    borderColor: "outline",
  },
});
